import { FlowStepRunner } from "../FlowStepRunner";
import { FlowExecutionData } from "../../Engine/FlowExecutionData";
import { RunExpression } from "./RunExpression";
import { IUserInfo } from "../../../Plugins/DataStorage/IUserInfo";
import { FlowEngine } from "../../Engine/FlowEngine";
import { ExecutionData } from "../../../Common/Data/ExecutionData/ExecutionData";
import { FlowStepTestContext } from "../../Structure/FlowTestingContext";

export class RunExpressionRunner extends FlowStepRunner<RunExpression> {
    async start(
        user: IUserInfo,
        thread: string,
        executionData: ExecutionData,
        flowExecutionData: FlowExecutionData,
        testContext?: FlowStepTestContext
    ): Promise<void> {
        let res = this.stepData!.expression.run(executionData, testContext);

        executionData.set(this.stepData!.outputVariableName ?? this.stepData!.name + "ExpressionResult", res);

        await FlowEngine.stepComplete(user, flowExecutionData, thread, this.stepData!, undefined, testContext);
    }
}
